import React, { useEffect, useState } from "react";
import { Menu, Button, MenuProps, Input, Modal, Tabs, Select, message, notification, Row, Col, Form, Spin, Checkbox } from 'antd';
import { useAppContext } from "../../../context/appContext";
import { CloseOutlined } from '@ant-design/icons';
import fetchUserSettingsInterval from "../../common/helpers/fetch-user-settings-interval";
import updateUserSettingsInterval from "../../common/helpers/update-user-settings-interval";
import { userId } from "../../../context/appContext";
const { TextArea } = Input;
const ManageIntervalsModal = ({ displayManageIntervals, setDisplayManageIntervals }) => {

    const [intervalSettings, setIntervalSettings] = useState({
        edge_case_interval: null,
        balance_interval: null,
        non_stream_interval: null,
    })

    useEffect(() => {
        if (userId) {
            fetchUserSettingsInterval(userId).then(res => {
                if (res) {
                    setIntervalSettings(res)
                } else {
                    setIntervalSettings({
                        edge_case_interval: 60,
                        balance_interval: 60,
                        non_stream_interval: 60,
                    })
                }
            })
        }
    }, [userId])



    const goBack = () => {
        setDisplayManageIntervals(false)
    }


    const handleIntervals = () => {
        updateUserSettingsInterval({ user_id: userId, data: intervalSettings }).then(res => {
            setDisplayManageIntervals(false)
            message.success('Changes Saved.')
        })
    }

    return (
        <Modal
            maskClosable={false}
            closeIcon={<CloseOutlined style={{ color: "white" }} />}
            bodyStyle={{
                backgroundColor: 'black',
                border: "1px solid grey"
            }}
            visible={displayManageIntervals} footer={null} onCancel={() => { setDisplayManageIntervals(false); }}>
            <div style={{ fontWeight: "600", color: "white" }}>Configure Intervals </div>

            <div style={{ color: "white", margin: "30px 0" }}>
                <label>Edge Case Handler Interval(sec)</label>
                <Input value={intervalSettings.edge_case_interval} onChange={(e) => { setIntervalSettings({ ...intervalSettings, edge_case_interval: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Enter Edge Case Handler Interval" />
            </div>

            <div style={{ color: "white", margin: "30px 0" }}>
                <label>Balance Check Interval(sec)</label>
                <Input value={intervalSettings.balance_interval} onChange={(e) => { setIntervalSettings({ ...intervalSettings, balance_interval: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Enter Balance Check Interval" />
            </div>

            <div style={{ color: "white", margin: "30px 0" }}>
                <label>Non-Stream Exchange Interval(sec)</label>
                <Input value={intervalSettings.non_stream_interval} onChange={(e) => { setIntervalSettings({ ...intervalSettings, non_stream_interval: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Enter Non-Stream Exchange Interval" />
            </div>

            <div style={{ display: "flex", flexDirection: "row", gap: 15, justifyContent: "space-between" }}>
                <Button onClick={() => { goBack() }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">BACK</Button>
                <Button onClick={() => {
                    handleIntervals();
                }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">OK</Button>
            </div>
        </Modal >
    );
};

export default ManageIntervalsModal;